<template>
    <div class="devicepicker">
        <a
            v-for="device__value in getAllDevices"
            v-bind:key="device__value"
            v-on:click.prevent="setCurrentDevice(device__value)"
            href="#"
            class="devicepicker__button"
            :class="[
                {
                    'devicepicker__button--active': isActiveDevice(device__value)
                },
                'devicepicker__button--type-' + device__value
            ]"
            v-tooltip="device__value.replace(/\w/, (c) => c.toUpperCase()) + '-Voransicht'"
        >
            {{ device__value }}
        </a>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    data() {
        return {};
    },
    components: {},
    methods: {
        ...mapActions(['setCurrentDevice'])
    },
    computed: {
        ...mapGetters(['getAllDevices', 'isActiveDevice'])
    },
    created() {},
    props: {}
};
</script>
